import React from 'react';
import { Card } from './ui/card';
import { Video, Play } from 'lucide-react';

const PatientEducationVideos = ({ content }) => {
  return (
    <section id="education-videos" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 mb-4">
              <Video className="w-6 h-6 text-teal-600" />
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900">
                Patient Education Videos
              </h2>
            </div>
            <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mt-6"></div>
          </div>
          
          <Card className="p-8 sm:p-12 border-slate-200 shadow-lg bg-white">
            <div className="flex items-start space-x-4 mb-6">
              <div className="p-3 bg-teal-100 rounded-lg">
                <Play className="w-6 h-6 text-teal-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold text-slate-900 mb-4">Coming Soon</h3>
                <p className="text-lg text-slate-700 leading-relaxed">
                  {content?.description}
                </p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default PatientEducationVideos;